import { render, staticRenderFns } from "./ExternalLinks.vue?vue&type=template&id=530c59c0"
import script from "./ExternalLinks.vue?vue&type=script&lang=js"
export * from "./ExternalLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/myapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530c59c0')) {
      api.createRecord('530c59c0', component.options)
    } else {
      api.reload('530c59c0', component.options)
    }
    module.hot.accept("./ExternalLinks.vue?vue&type=template&id=530c59c0", function () {
      api.rerender('530c59c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/ExternalLinks.vue"
export default component.exports